import React from 'react';
import { useFeatureFlagContext } from '@modules/feature-flags/client/providers/FeatureFlagProvider';

export type ComponentExtension = {
  id: string;
  component: React.ComponentType;
  order: number;
  featureFlag?: string;
};

class ComponentExtensionRegistryClass {
  private _extensions: Map<string, ComponentExtension[]> = new Map();

  register(extensionPoint: string, extension: ComponentExtension): void {
    const existing = this._extensions.get(extensionPoint) ?? [];
    this._extensions.set(extensionPoint, [...existing, extension]);
  }

  unregister(extensionPoint: string, id: string): void {
    const existing = this._extensions.get(extensionPoint) ?? [];
    this._extensions.set(
      extensionPoint,
      existing.filter((ext) => ext.id !== id),
    );
  }

  getExtensions(extensionPoint: string): ComponentExtension[] {
    return [...(this._extensions.get(extensionPoint) ?? [])].sort((a, b) => a.order - b.order);
  }
}

export const ComponentExtensionRegistry = new ComponentExtensionRegistryClass();

export const useComponentExtensions = (extensionPoint: string): ComponentExtension[] => {
  const { isEnabled } = useFeatureFlagContext();
  return ComponentExtensionRegistry.getExtensions(extensionPoint).filter(
    (ext) => !ext.featureFlag || isEnabled(ext.featureFlag),
  );
};
